export default __webpack_public_path__ + "static/media/REDUX.e4adedd5.jpg";